









import { settingsActionsLists } from '@service/store/settings/actions-list';
import Loadable from '@share/common/service-components/loadable/Loadable.vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'LanguageSwitcher'
})
export default class LanguageSwitcher extends Loadable {
    @Prop() value: string;

    loadedLanguages: string[] | null = null;

    created() {
        this.updateLanguages();
    }

    async updateLanguages() {
        try {
            this.isLoading = true;
            this.loadedLanguages = await this.$store.dispatch(settingsActionsLists.loadLanguages);
        }
        catch(e) {
            this.$store.dispatch('reportError', e);
        }
        finally {
            this.isLoading = false;
        }
    }

    getLangTitle(lang: string) {
        let langTitle;

        switch (lang) {
            case "ru":
                langTitle = "Русский"
                break;
            case "en":
                langTitle = "English"
                break;
            case "uk":
                langTitle = "Українська"
                break;
            case "zh":
                langTitle = "中文"
                break;

            default:
                langTitle = lang
                break;
        }

        return langTitle;
    }

    get languages() {

        if(this.isLoading) {
            return [];
        }

        if(this.loadedLanguages) {
            return this.loadedLanguages.map((lang) => ({ code: lang, title: this.getLangTitle(lang) }))
        }
        else {
            return [
                {code: "ru", title: this.getLangTitle("ru")},
                {code: "en", title: this.getLangTitle("en")},
                {code: "uk", title: this.getLangTitle("uk")},
                {code: "zh", title: this.getLangTitle("zh")}
            ]
        }
    }

    get language(): string {
        return this.value;
    }

    set language(value: string) {
        this.$emit('input', value);
    }
}
